import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
// import LoginPage from './components/LoginPage';
// import RegisterPage from './components/RegisterPage';
import LoginPage from './authentication/Login';
import RegisterPage from './authentication/Register';
import Dashboard from './components/TestDashboard';
// import ChatPage from './components/ChatPage';
// import ChatPage from './components/MessageSummaryPage';
import ChatPage from './components/ChatPageUpdate2';
// import ChatPage from './components/ChatPageOri';
import ChatHistoryPage from './components/ChatHistoryPage';
// import ChatSummaryPage from './components/ChatSummaryPage';
// import ChatSummaryPage from './components/MessageSummaryPage';
import ChatSummaryPage from './components/ChatSummaryPage3';
import NotificationManagementPage from './components/NotificationManagementPage';
import NotificationsAll from './components/NotificationsAll';
import UsersPage from './components/UsersPage';
import SummaryPage from './components/ChatSummaryOri';

function App() {
  // Add state for authentication
  const [isAuthenticated, setIsAuthenticated] = useState(
    localStorage.getItem('authToken') !== null
  );

  // Protected route component
  const ProtectedRoute = ({ children }) => {
    if (!isAuthenticated) {
      return <Navigate to="/login" replace />
    }
    return children;
  }

  return (
    <div className="App">
      {/* <LoginPage /> */}
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage setIsAuthenticated={setIsAuthenticated} />} />
          <Route path="/register" element={<RegisterPage />} />
          {/* Redirect to login page by default */}
          {/* <Route path="/" element={<Navigate to="/login" replace />} /> */}
          {/* You can add more routes for authenticated pages later */}

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/summary"
            element={
              // <ProtectedRoute>
                // <SummaryPage />
                <ChatSummaryPage />
              // </ProtectedRoute>
            }
          />
          <Route
            path="/chat"
            element={
              // <ProtectedRoute>
                <ChatPage />
              // </ProtectedRoute>
            }
          />
          <Route
            path="/chat-history"
            element={
              <ProtectedRoute>
                <ChatHistoryPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/chat-summary"
            element={
              // <ProtectedRoute>
                <ChatSummaryPage />
              // </ProtectedRoute>
            }
          />
          <Route
            path="/notifications"
            element={
              <ProtectedRoute>
                <NotificationManagementPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/notification-all"
            element={
              <ProtectedRoute>
                <NotificationsAll />
              </ProtectedRoute>
            }
          />
           <Route
            path="/users"
            element={
              <ProtectedRoute>
                <UsersPage />
              </ProtectedRoute>
            }
          />
          {/* Redirect to chat if authenticated, otherwise to login  */}
          <Route
            path="/"
            element={
              isAuthenticated ? (
                <Navigate to="/chat" replace />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
        </Routes>
      </Router>
    </div>
  );
};

export default App;